export default __webpack_public_path__ + "static/ausgetauscht-logo-725b5e927be35caf6f51922cb0978712.png";